import { Button, Card, Form, Input, message, Space, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ContentWithErrorHandler from '../../app/ContentWithErrorHandler';
import quillConfig from '../../common/quillConfig';
import { useCreatePoolMutation, useGetPoolQuery, useUpdatePoolMutation } from './lotteryAPI';

function LotteryPoolDetail() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [description, setDescription] = useState('');
  const isCreate = !id;

  const { data: poolData, isLoading: isLoadingPool } = useGetPoolQuery(Number(id), {
    skip: isCreate,
  });

  const [createPool, { isLoading: isCreating }] = useCreatePoolMutation();
  const [updatePool, { isLoading: isUpdating }] = useUpdatePoolMutation();

  useEffect(() => {
    if (poolData && !isCreate) {
      form.setFieldsValue({
        name: poolData.name,
        isActive: poolData.isActive,
      });
      setDescription(poolData.description || '');
    }
  }, [poolData, isCreate, form]);

  const onFinish = async (values: any) => {
    try {
      const payload = {
        ...values,
        description,
      };
      if (isCreate) {
        await createPool(payload).unwrap();
        message.success('Data undian berhasil dibuat');
      } else {
        await updatePool({ id: Number(id), ...payload }).unwrap();
        message.success('Data undian berhasil diperbarui');
      }
      navigate('/lottery/pools');
    } catch (err: any) {
      message.error(err.data?.message || 'Gagal menyimpan data undian');
    }
  };

  return (
    <ContentWithErrorHandler isError={false} isLoading={isLoadingPool}>
      <Card title={isCreate ? 'Tambah Data Undian' : 'Edit Data Undian'} size="small">
        <Form form={form} layout="vertical" onFinish={onFinish} initialValues={{ isActive: true }}>
          <Form.Item label="Nama Undian" name="name" rules={[{ required: true, message: 'Silakan masukkan nama undian' }]}>
            <Input placeholder="Masukkan nama undian" />
          </Form.Item>

          <Form.Item label="Deskripsi">
            <ReactQuill
              modules={quillConfig}
              style={{
                background: 'white',
              }}
              onChange={(content) => setDescription(content)}
              value={description}
            />
          </Form.Item>

          <Form.Item label="Aktif" name="isActive" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={isCreating || isUpdating}>
                {isCreate ? 'Buat' : 'Perbarui'}
              </Button>
              <Button onClick={() => navigate('/lottery/pools')}>Batal</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </ContentWithErrorHandler>
  );
}

export default LotteryPoolDetail;
